import { request } from "./request";
import type { components } from "./schema";

// Create user
type CreateUserResponse = components["schemas"]["CreateUserResponse"];
type CreateUserRequest = components["schemas"]["CreateUserRequest"];

export async function postCreateUser(body: CreateUserRequest) {
  return request<CreateUserResponse>("/users", {
    method: "POST",
    body: JSON.stringify(body),
  });
}

// Get current user info
type GetCurrentUserResponse = components["schemas"]["GetCurrentUserResponse"];

export async function getCurrentUser() {
  return request<GetCurrentUserResponse>("/me");
}

// Update current user info
type UpdateCurrentUserResponse =
  components["schemas"]["UpdateCurrentUserResponse"];
type UpdateCurrentUserRequest =
  components["schemas"]["UpdateCurrentUserRequest"];

export async function putUpdateCurrentUser(body: UpdateCurrentUserRequest) {
  return request<UpdateCurrentUserResponse>("/me", {
    method: "PUT",
    body: JSON.stringify(body),
  });
}

// Delete current user
export async function deleteCurrentUser() {
  return request<UpdateCurrentUserResponse>("/me", {
    method: "DELETE",
  });
}

// Update current user email
type UpdateCurrentUserEmailResponse =
  components["schemas"]["UpdateCurrentUserEmailResponse"];
type UpdateCurrentUserEmailRequest =
  components["schemas"]["UpdateCurrentUserEmailRequest"];

export async function putUpdateCurrentUserEmail(
  body: UpdateCurrentUserEmailRequest
) {
  return request<UpdateCurrentUserEmailResponse>("/me/email", {
    method: "PUT",
    body: JSON.stringify(body),
  });
}

// Send email verification code
export async function postSendEmailVerificationCode() {
  return request<void>("/me/email/send-code", {
    method: "POST",
  });
}

// Verify email
type VerifyCurrentUserEmailResponse =
  components["schemas"]["VerifyCurrentUserEmailResponse"];
type VerifyCurrentUserEmailRequest =
  components["schemas"]["VerifyCurrentUserEmailRequest"];

export async function postVerifyCurrentUserEmail(
  body: VerifyCurrentUserEmailRequest
) {
  return request<VerifyCurrentUserEmailResponse>("/me/email/verify", {
    method: "POST",
    body: JSON.stringify(body),
  });
}

// Delete palm model
export async function deleteCurrentUserPalm(palmId: string) {
  return request<void>(`/me/palms/${palmId}`, {
    method: "DELETE",
  });
}

// Verify palm model
export type CurrentUserVerifyPalmResponse =
  components["schemas"]["CurrentUserVerifyPalmResponse"];
type CurrentUserVerifyPalmRequest =
  components["schemas"]["CurrentUserVerifyPalmRequest"];

export async function postVerifyCurrentUserPalm(
  body: CurrentUserVerifyPalmRequest
) {
  return request<CurrentUserVerifyPalmResponse>("/me/verify-palm", {
    method: "POST",
    body: JSON.stringify(body),
  });
}

// Refresh access token
type RefreshTokenResponse = components["schemas"]["RefreshTokenResponse"];
type RefreshTokenRequest = components["schemas"]["RefreshTokenRequest"];

export async function postRefreshToken(body: RefreshTokenRequest) {
  return request<RefreshTokenResponse>("/auth/refresh", {
    method: "POST",
    body: JSON.stringify(body),
  });
}

// Identify user
export type UserIdentifyResponse =
  components["schemas"]["UserIdentifyResponse"];
type UserIdentifyRequest = components["schemas"]["UserIdentifyRequest"];

export async function postUserIdentify(body: UserIdentifyRequest) {
  return request<UserIdentifyResponse>("/users/identify", {
    method: "POST",
    body: JSON.stringify(body),
  });
}

// /palm-verification-nonce
type PalmVerificationNonceResponse =
  components["schemas"]["PalmVerificationNonceResponse"];

export async function postPalmVerificationNonce() {
  return request<PalmVerificationNonceResponse>("/palm-verification-nonce", {
    method: "POST",
  });
}

type ReactivateCurrentUserResponse =
  components["schemas"]["ReactivateCurrentUserResponse"];

export async function postReactivateUser() {
  return request<ReactivateCurrentUserResponse>("/me/reactivate", {
    method: "POST",
  });
}

type VerifyUserPalmRequest = components["schemas"]["UserVerifyPalmRequest"];
export type VerifyUserPalmResponse =
  components["schemas"]["UserVerifyPalmResponse"];

export async function postVerifyUserPalm(body: VerifyUserPalmRequest) {
  return request<VerifyUserPalmResponse>("/users/verify-palm", {
    method: "POST",
    body: JSON.stringify(body),
  });
}

type UserSigninResponse = components["schemas"]["UserSigninResponse"];
type UserSigninRequest = components["schemas"]["UserSigninRequest"];

export async function postUserSignin(body: UserSigninRequest) {
  return request<UserSigninResponse>("/users/signin", {
    method: "POST",
    body: JSON.stringify(body),
  });
}

type PalmVerificationPreflightResponse =
  components["schemas"]["PalmVerificationPreflightResponse"];
type PalmVerificationPreflightRequest =
  components["schemas"]["PalmVerificationPreflightRequest"];

export async function postPalmVerificationPreflight(
  body: PalmVerificationPreflightRequest,
  signal?: AbortSignal
) {
  return request<PalmVerificationPreflightResponse>(
    "/palm-verification-preflight",
    {
      method: "POST",
      body: JSON.stringify(body),
      signal,
    }
  );
}

type UserReregisterPalmsRequest =
  components["schemas"]["UserReregisterPalmsRequest"];
type ReregisterPalmsResponse = components["schemas"]["ReregisterPalmsResponse"];

export async function postReregisterUserPalms(
  body: UserReregisterPalmsRequest
) {
  return request<ReregisterPalmsResponse>("/users/reregister-palms", {
    method: "POST",
    body: JSON.stringify(body),
  });
}

type RegisterPalmsRequest = components["schemas"]["RegisterPalmsRequest"];
type RegisterPalmsResponse = components["schemas"]["RegisterPalmsResponse"];

export async function postMeRegisterPalms(body: RegisterPalmsRequest) {
  return request<RegisterPalmsResponse>("/me/register-palms", {
    method: "POST",
    body: JSON.stringify(body),
  });
}


type AuthEmailOtpRequest = components["schemas"]["AuthEmailOtpRequest"];


export async function postAuthEmailOtp(body: AuthEmailOtpRequest) {
  return request<void>("/auth/email/otp", {
    method: "POST",
    body: JSON.stringify(body),
  });
}

type UserAuthenticateRequest = components["schemas"]["UserAuthenticateRequest"];
type UserAuthenticateResponse = components["schemas"]["UserAuthenticateResponse"];

export async function postUserAuthenticate(body: UserAuthenticateRequest) {
  return request<UserAuthenticateResponse>("/users/authenticate", {
    method: "POST",
    body: JSON.stringify(body),
  });
}